/**
 * Build/runtime constants. The one place base-url and app title come from
 * (mirrors shop/ui/src/config.ts).
 *
 * In dev the vite proxy forwards /v2 to the auditor server (vite.config.ts);
 * in prod the built dist/ is served same-origin by the auditor server. Either
 * way the API base is empty by default; VITE_API_BASE exists only as an
 * escape hatch for a split-origin deployment.
 */

/** HTTP API base URL. Empty string => same origin (default). No trailing slash. */
export const API_BASE = (import.meta.env.VITE_API_BASE ?? '').replace(/\/$/, '');

/** App version string shown in the dashboard footer. */
export const APP_VERSION = import.meta.env.VITE_APP_VERSION ?? '2.0.0-dev';

/** App title, used in the login card and the shell header. */
export const APP_TITLE = '1NL Auditor';

/** Cloudflare Turnstile site key (DEPLOYMENT-PLAN.md item 6.6). Empty string
 *  => the login card renders no widget and sends no token, exactly as it did
 *  before the feature existed; the server's TURNSTILE_SECRET is the matching
 *  switch on its side. */
export const TURNSTILE_SITE_KEY = (import.meta.env.VITE_TURNSTILE_SITE_KEY ?? '').trim();
